import { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";

function getClientId() {
  let id = sessionStorage.getItem("ng_client_id");
  if (!id) {
    id = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("ng_client_id", id);
  }
  return id;
}

export function usePresence(releaseSlug) {
  const [count, setCount] = useState(null);
  const clientIdRef = useRef(getClientId());

  useEffect(() => {
    if (!releaseSlug) return;
    let cancelled = false;
    const beat = async () => {
      try {
        const { data } = await api.post("/presence/heartbeat", {
          release_slug: releaseSlug,
          client_id: clientIdRef.current,
        });
        if (!cancelled && typeof data.count === "number") setCount(data.count);
      } catch (e) {
        if (!cancelled) setCount(null);
      }
    };
    beat();
    const interval = setInterval(beat, 25000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [releaseSlug]);

  return count;
}
